import { Ref } from 'vue'
import { Router } from 'vue-router'
import { useRouter } from './router'
import { useActions, useState } from './useStore'

interface AppStateApi {
  currentProduct: Ref<string>
  setCurrentProduct: (product: string) => void
}

const { currentProduct } = useState<{ currentProduct: string }>('App', ['currentProduct'])
const { setCurrentProduct: _setCurrentProduct } = useActions<{
  setCurrentProduct: (payload: { product: string; router: Router }) => void
}>('App', ['setCurrentProduct'])
const router = useRouter()

function setCurrentProduct(product: string) {
  _setCurrentProduct({ product, router: router.value })
}

export function useAppState(): AppStateApi {
  return {
    currentProduct,
    setCurrentProduct
  }
}
